<template>
<div>
<b-modal id="confirmDeleteModal" hide-footer v-bind:title="$t('title') + '!'" centered>
  <div class="d-block">
    <!--<h3>{{$t('title')}}!</h3>-->
    <p>
      {{$t('confirmText')}}
      {{$t('type.' + type)}}?
    </p>
  </div>
  <div class="row">
    <div class="col-6">
      <b-button class="mt-3" block @click="$bvModal.hide('confirmDeleteModal')">
        {{$t('cancel')}}
      </b-button>
    </div>
    <div class="col-6">
      <b-button class="mt-3 btn-danger" block @click="confirm">
        {{$t('delete')}}
      </b-button>
    </div>
  </div>
</b-modal>
</div>
</template>

<script>
export default {
  name: 'ConfirmDelete',
  props: ['type', 'delete'],
  methods: {
    confirm(){
      this.$bvModal.hide('confirmDeleteModal');
      this.delete(0);
    }
  }
}
</script>

<i18n>
{
  "en": {
    "title": "Confirm Delete",
    "confirm": "Are you sure you want to delete this",
    "cancel": "Cancel",
    "delete": "Delete",
    "type": {
      "guest": "guest",
      "booking": "booking",
      "price": "price",
      "room": "room",
      "property": "property"
    }
  },
  "sl": {
    "title": "Potrdite izbris",
    "confirmText": "Ali ste prepričani, da želite pobrisati",
    "cancel": "Prekliči",
    "delete": "Izbriši",
    "type": {
      "guest": "gosta",
      "booking": "rezervacijo",
      "price": "ceno",
      "room": "sobo",
      "property": "nastanitev"
    }
  }
}
</i18n>
